import React from 'react';
import { colors, typography, layout } from '../articleMinimalStyles';

const ArticleHeader = ({ title, category, date, imageUrl, imageAlt }) => {

  const styles = {
    headerContainer: {
      marginBottom: '30px',
      paddingBottom: '30px',
      borderBottom: `1px solid ${colors.border}`,
    },
    categoryBadge: {
      display: 'inline-block',
      marginBottom: '15px',
      padding: '5px 12px',
      borderRadius: '20px',
      backgroundColor: colors.lightBlue || '#e7f0ff', // Use a light background
      color: colors.accent, // Use accent color
      fontSize: typography.smallSize,
      fontWeight: typography.mediumWeight,
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },
    title: {
      fontSize: typography.h1Size, // Large title for article
      fontWeight: typography.boldWeight,
      color: colors.primaryText,
      lineHeight: 1.3,
      marginBottom: '15px',
    },
    metaInfo: {
      fontSize: typography.smallSize,
      color: colors.secondaryText,
    },
    featuredImageContainer: {
      marginTop: '30px',
      borderRadius: '8px',
      overflow: 'hidden',
      backgroundColor: colors.backgroundLight, // Placeholder bg
    },
    featuredImage: {
      width: '100%',
      height: 'auto',
      maxHeight: '500px', // Limit image height
      objectFit: 'cover',
      display: 'block',
    },
  };

  return (
    <header style={styles.headerContainer}>
      {category && <span style={styles.categoryBadge}>{category}</span>}
      <h1 style={styles.title}>{title}</h1>
      {date && <p style={styles.metaInfo}>Published on {date}</p>}
      {imageUrl && (
        <div style={styles.featuredImageContainer}>
          <img src={imageUrl} alt={imageAlt || title} style={styles.featuredImage} loading="lazy" />
        </div>
      )}
    </header>
  );
};

export default ArticleHeader;